module.exports = __webpack_public_path__ + "static/comunicados-37e958e992b3def5866d6c8f577f977d.jpg";